import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  messageTemplatesApi,
  messageTemplateDetail,
  createMessageTemplate,
  updateMessageTemplate,
  deleteMessageTemplate,
} from "../api/messageTemplatesApi";
import { useAuth } from "../../../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { SuccessMessage, ErrorMessage } from "../../../../utils/toastify";

export const useFetchTemplatesMessage = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useQuery({
    queryKey: ["messageTemplates"],
    queryFn: async () =>
      await messageTemplatesApi({
        token: user.token,
        uidPartner: user?.uid_partner,
      }),
    initialData: [],
    refetchOnWindowFocus: false,
  });
};

export const useFetchDetailTemplatesMessage = (uuid) => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useQuery({
    queryKey: ["messageTemplateDetail", uuid],
    enabled: !!uuid,
    initialData: {},
    refetchOnWindowFocus: false,
    queryFn: async () => {
      return await messageTemplateDetail({
        token: user.token,
        uidPartner: user?.uid_partner,
        uuid: uuid,
      });
    },
  });
};

export const useCreateTemplatesMessage = (isFromCampaign = false) => {
  const queryClient = useQueryClient();
  const auth = useAuth();
  const user = auth.getSessionData();
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ["createMessageTemplate"],
    mutationFn: async (data) =>
      await createMessageTemplate({
        token: user.token,
        uidPartner: user?.uid_partner,
        data,
      }),
    onSuccess: (data) => {
      if (data?.error) {
        ErrorMessage("Ha ocurrido un error al crear el template");

        return;
      }

      if (!isFromCampaign) {
        queryClient.invalidateQueries({
          queryKey: ["messageTemplates"],
        });
        navigate("/rcs/MessageTemplates");
      } else {
        queryClient.invalidateQueries({
          queryKey: ["messageTemplatesForCampaigns"],
        });
      }
      SuccessMessage("Se ha creaido el template exitosamente");
    },
  });
};

export const useUpdateTemplatesMessage = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useMutation({
    mutationKey: ["updateMessageTemplate"],
    mutationFn: async (data) =>
      await updateMessageTemplate({
        token: user.token,
        uidPartner: user?.uid_partner,
        uuid: data?.uuid_messages_templates,
        data,
      }),
    onSuccess: (data) => {
      if (data?.error) {
        ErrorMessage("Ha ocurrido un error al actualizar el template");
        return;
      }

      SuccessMessage("Se ha actualizado el template exitosamente");
    },
  });
};

export const useDeleteTemplatesMessage = () => {
  const queryClient = useQueryClient();
  const auth = useAuth();
  const user = auth.getSessionData();

  return useMutation({
    mutationKey: ["deleteMessageTemplate"],
    mutationFn: async (uuid_template) => {
      return await deleteMessageTemplate({
        token: user.token,
        uidPartner: user?.uid_partner,
        uuid: uuid_template,
      });
    },
    onSuccess: (data) => {
      if (data?.error) {
        ErrorMessage("Ha ocurrido un error al eliminar el template");
        return;
      }

      queryClient.invalidateQueries({
        queryKey: ["messageTemplates"],
      });

      SuccessMessage("Se ha eliminado el template exitosamente");
    },
  });
};
